import styled from 'styled-components';
import { IFrame } from './interface';

const base = styled.div<IFrame>`
  display: ${(props) => (props.isActive === true ? 'flex' : 'none')};
  width: 100%;
  max-width: 100%;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
  > div {
    width: 100%;
  }
  @media (min-width: 1024px) {
    > div {
      margin: 15px 0;
      max-width: calc(50% - 15px);
    }
  }
`;

const Frame = {
  Base: base,
};

export default Frame;
